<template lang="pug">
    div.pa-md-5.width-100-percent.fill-height(style="height: 100vh;" ref="indexBody")
        v-snackbar(
            v-model='snackbar.show'
            :color='snackbar.color'
            :timeout="snackbar.timeout"
            top
        )
            | {{ snackbar.text }}
            v-btn(dark text @click='snackbar.show = false')
                | Close

        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px; margin-bottom: 100px;"
            )

        v-card.brown.lighten-5.mx-lg-auto(
            width="100%"
            style="height: 100vh;"
            v-bind:style="{ height: bodyHeight + 'px' }"
            v-else
        )
            v-toolbar(light)
                v-col(cols='8')
                v-text-field(dense @click='searchDialog = true' @click:append='() => searchDialog = true' @click:prepend-inner='() => searchDialog = true' prepend-inner-icon='mdi-magnify' label='Search' single-line hide-details readonly outlined filled )
                v-dialog(v-model='searchDialog' max-width='600px')
                    v-card
                        v-card-title
                            span.text-h5 Search Messages
                        v-card-text
                            v-container
                                v-row
                                    v-col.no-top-bottom-padding(cols='6')
                                        v-menu(
                                            v-model='startDatePickerMenu'
                                            :close-on-content-click='false'
                                            transition='scale-transition'
                                            offset-y
                                            max-width='290px'
                                            min-width='290px'
                                        )
                                            template(v-slot:activator='{ on, attrs }')
                                                v-text-field(
                                                    v-model='formatStartTimeDate'
                                                    label='Start Date'
                                                    prepend-icon='mdi-calendar'
                                                    readonly
                                                    v-bind='attrs'
                                                    v-on='on'
                                                    clearable
                                                    @click:clear='searchObj.start_date = null;'
                                                )
                                            v-date-picker(
                                                v-model='searchObj.start_date'
                                                no-title
                                                @change="handleChangeStartDate"
                                                @input='startDatePickerMenu = false'
                                            )
                                    v-col.no-top-bottom-padding(cols='6')
                                        v-menu(
                                            v-model='endDatePickerMenu'
                                            :close-on-content-click='false'
                                            transition='scale-transition'
                                            offset-y
                                            max-width='290px'
                                            min-width='290px'
                                        )
                                            template(v-slot:activator='{ on, attrs }')
                                                v-text-field(
                                                    v-model='formatEndTimeDate'
                                                    label='End Date'
                                                    prepend-icon='mdi-calendar'
                                                    readonly
                                                    v-bind='attrs'
                                                    v-on='on'
                                                    clearable
                                                    @click:clear='searchObj.end_date = null;'
                                                )
                                            v-date-picker(
                                                v-model='searchObj.end_date'
                                                no-title
                                                @change="handleChangeEndDate"
                                                @input='endDatePickerMenu = false'
                                            )
                                v-row
                                    v-col(cols='6')
                                        OrganizationSelect(
                                            v-model='searchObj.organizationId'
                                            :organization-users='organizationUsers'
                                            label='Organization'
                                            clearable
                                            @change="handleChangeOrganization"
                                        )
                                    v-col(cols='6')
                                        v-autocomplete(v-model='searchObj.campaignId' :items='campaigns' label='Campaign' item-text="campaign_name" item-value="campaign_id" clearable :disabled="campaignFilterDisabled")
                                v-row
                                    v-col(cols='6')
                                        CustomerSearch(
                                            :email="searchObj.customerEmail"
                                            :handle-search="handleCustomerSearch"
                                            :first-name="searchObj.customerFirstName"
                                            :last-name="searchObj.customerLastName"
                                            :organization-id="searchObj.organizationId"
                                            :organization-users="organizationUsers"
                                            :phone="searchObj.customerPhone"
                                        )
                                    v-col(cols='6')
                                        v-autocomplete(v-model='searchObj.direction' :items='directions' label='Direction' item-text="key" item-value="value" clearable)
                                v-row
                                    v-col(cols='6')
                                        v-text-field(label='SID' type='text' v-model="searchObj.sid" clearable)
                                    v-col(cols='6')
                                        v-text-field(label='VID' type='text' v-model="searchObj.message_key" clearable)
                        v-card-actions
                            v-spacer
                            v-btn.ma-2(color="var(--volie-blue)" outlined ripple left @click='searchDialog = false;')
                                v-icon mdi-window-close
                                | Close
                            v-btn.ma-2(color="var(--volie-blue)" outlined ripple left @click='searchDialog = false; reinitSearch();')
                                v-icon mdi-refresh
                                | Reset
                            v-btn.ma-2(color="var(--volie-blue)" style="color: white;" ripple left @click='searchDialog = false; searchMessages();')
                                v-icon mdi-magnify
                                | Search

            v-card-text.pa-0(
                v-bind:style="{ height: cardTextHeight + 'px' }"
            )
                MessageTable(
                    style="height: 100vh;"
                    :messages='messages'
                    :height="messagesTableHeight"
                    :is-loading='isLoading'
                    :is-show-more-loading='isShowMoreLoading'
                    :handle-show-more='handleShowMore'
                    :limit="limit"
                    :show-moreable='showMoreable'
                )

            v-alert(outlined type='info' dense border='left' style="margin-top: 16px;" v-if="messages.length === 0")
                | Unable to find any messages. Please adjust your search criteria.

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // Components
    import CustomerSearch from "@/components/customers/contact_info_search.vue";
    import MessageTable from '@/components/messages/table.vue';
    import OrganizationSelect from '@/components/shared/organization_select.vue';

    // Data
    import {
        GetCampaigns,
        GetMessages,
        GetOrganizationUsers,
    } from "@/data";

    export default Vue.extend({
        data() {
            return {
                bodyHeight: null,
                campaigns: [],
                cardTextHeight: null,
                dialog: false,
                directions: [
                    {
                        key: 'Incoming',
                        value: 'incoming',
                    },
                    {
                        key: 'Outgoing',
                        value: 'outgoing',
                    },
                ],
                endDatePickerMenu: false,
                formatEndTimeDate: null,
                formatStartTimeDate: null,
                isLoading: false,
                isShowMoreLoading: false,
                lastMessageId: 0,
                limit: 100,
                messages: [],
                messagesTableHeight: null,
                organizationUsers: [],
                searchDialog: false,
                searchObj: {},
                showMoreable: true,
                snackbar: {
                    show: false,
                    timeout: 2500,
                },
                startDatePickerMenu: false,
                toggle: null,
            }
        },
        methods: {
            formatDate (date) {
                if (!date) {
                    return null;
                }

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`;
            },
            getCampaigns() {
                if (!(this.searchObj?.organizationId > 0)) {
                    this.campaigns = [];
                    return;
                }

                GetCampaigns({organization_id: this.searchObj.organizationId}).then((response) => {
                    if (!!response.Data && !!response.Data.campaigns && response.Data.campaigns.length > 0) {
                        this.campaigns = response.Data.campaigns;
                    }
                });

                return;
            },
            getMessages() {

                // If lock user ID is -1, then something is wrong with the session
                if (this.lockUserId === -1) {
                    this.isLoading = false;
                    return;
                }

                const options = {
                    campaign_id: (this.searchObj?.campaignId || 0),
                    customer_email: (this.searchObj?.customerEmail || ""),
                    customer_first_name: (this.searchObj?.customerFirstName || ""),
                    customer_last_name: (this.searchObj?.customerLastName || ""),
                    customer_phone: (this.searchObj?.customerPhone || ""),
                    direction: this.searchObj.direction || '',
                    end_date: this.searchObj.end_date || '',
                    last_message_id: this.lastMessageId || 0,
                    limit: this.limit,
                    message_key: this.searchObj.message_key || '',
                    message_types: ["mms", "sms"],
                    organization_id: this.searchObj.organizationId || 0,
                    sent_by: (this.lockUserId || 0),
                    sid: this.searchObj.sid || '',
                    start_date: this.searchObj.start_date || '',
                }

                if (this.messages?.length > 0) {
                    this.isShowMoreLoading = true;
                } else {
                    this.isLoading = true;
                }

                GetMessages(options).then((response) => {
                    if (response?.Data?.messages?.length > 0) {

                        this.showMoreable = true;

                        this.lastMessageId = response.Data.messages[response.Data.messages.length - 1].message_id;

                        if (!!this.messages && this.messages.length > 0) {
                            this.messages = this.messages.concat(response.Data.messages);
                        } else {
                            this.messages = response.Data.messages;
                        }
                    } else {
                        this.showMoreable = false;
                    }

                    this.isLoading = false;
                    this.isShowMoreLoading = false;
                });
            },
            getOrganizationUsers() {
                GetOrganizationUsers().then((response) => {
                    if (!!response.Data && !!response.Data.organization_users && response.Data.organization_users.length > 0) {
                        this.organizationUsers = response.Data.organization_users;
                    }
                });

                return;
            },
            handleChangeEndDate() {
                this.formatEndTimeDate = this.formatDate(this.searchObj?.end_date);
            },
            handleChangeOrganization() {
                this.campaigns = [];
                this.getCampaigns();
            },
            handleChangeStartDate() {
                this.formatStartTimeDate = this.formatDate(this.searchObj?.start_date);
            },
            handleCustomerSearch(obj) {
                this.searchObj.customerEmail     = obj?.email || null;
                this.searchObj.customerFirstName = obj?.firstName || null;
                this.searchObj.customerLastName  = obj?.lastName || null;
                this.searchObj.customerPhone     = obj?.phone || null;
                this.searchObj.organizationId    = obj?.organizationId || null;
            },
            handleShowMore() {
                this.getMessages();
            },
            handleWindowResize() {

                // Declare constants
                // const paddingPx = 2;
                // const toolbarHeight = 48;
                // const tabBarHeight = 48;
                // const colPaddingAndMargin = 47.109;
                let bannerHeight = 0;
                if (this.source === "messages_index") {
                    bannerHeight = 64;
                }

                let liveDash = 0;
                if (this.source === "live_dashboard") {
                    liveDash = 8 + 64; // banner
                }

                // Calcuate
                this.bodyHeight = this.$refs.indexBody?.clientHeight - bannerHeight - liveDash - 57 - 42;
                // this.bodyWidth = this.$refs.indexBody?.clientWidth;
                this.cardTextHeight = this.bodyHeight - 32;
                this.messagesTableHeight = this.cardTextHeight - 64;
            },
            reinitSearch() {
                this.resetSearchObj();
                this.searchMessages();
            },
            resetSearchObj() {
                this.searchObj = {
                    campaignId: null,
                    customerEmail: null,
                    customerFirstName: null,
                    customerLastName: null,
                    customerPhone: null,
                    direction: null,
                    end_date: null,
                    message_key: null,
                    organizationId: null,
                    sid: null,
                    start_date: null,
                }

                this.formatEndTimeDate = null;
                this.formatStartTimeDate = null;
            },
            searchMessages() {
                this.isLoading = true;
                this.lastMessageId = null;
                this.messages = [];
                this.getMessages();
            },
            setHtmlOverflow(value) {
                const htmlTag = document.getElementsByTagName('html')[0];
                if (!!htmlTag) {

                    // remove tags
                    htmlTag.classList.remove('overflow-y-hidden');
                    htmlTag.classList.remove('overflow-y-scroll');

                    // If hidden, need to scroll back to top
                    if (value === "hidden") {
                        window.scrollTo(0, 0);
                        htmlTag.classList.add('overflow-y-hidden');

                    } else if(value === "scroll"){
                        htmlTag.classList.add('overflow-y-scroll');
                    }
                }
                return;
            },
            showSnackbar(color, text) {
                if (color?.length > 0 && text?.length > 0) {
                    this.snackbar.color = color;
                    this.snackbar.text = text;
                    this.snackbar.show = true;
                }
            },
        },
        computed: {
            campaignFilterDisabled() {
                return !(this.searchObj?.organizationId > 0) || this.campaigns.length === 0;
            },
            showMore() {
                return (this.messages?.length > 0 && this.messages.length % this.limit === 0);
            },
        },
        props: {
            currentNavigation: String,
            forceOrganizationUsers: Array,
            inCommunicationCenter: Boolean,
            lockUserId: Number,
            selectedView: String,
            source: String,
            viewProfile: Function,
        },
        watch: {
            currentNavigation() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            isLoading() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            selectedView() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
        },
        components: {
            CustomerSearch,
            MessageTable,
            OrganizationSelect,
        },
        destroyed() {
            this.setHtmlOverflow("scroll");
            window.removeEventListener('resize', this.handleWindowResize);
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);
            this.reinitSearch();
            return this.forceOrganizationUsers?.length > 0 ? (this.organizationUsers = this.forceOrganizationUsers) : this.getOrganizationUsers();
        },
        mounted() {
            this.setHtmlOverflow("hidden");
            this.handleWindowResize();
        },
    });
</script>

<style lang="scss" scoped>
</style>
